import { AnyAction, Reducer } from "redux";
import produce from "immer";

import { createInstanceMapReducer, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IInitLinkButtonAction, ILinkButtonClearAction, ILinkButtonSetLoadingAction, ILinkButtonState, IUpdateLinkButtonOptionsAction, LinkButtonMapState } from "./types";

const LINK_BUTTON_INIT_STATE: ILinkButtonState = {
    url: "",
    params: [],
    functions: [],
    isLoading: false,
};

export const linkButtonReducer: Reducer<ILinkButtonState> = (state = LINK_BUTTON_INIT_STATE, action) => {
    if (action instanceof IInitLinkButtonAction)
        return { ...action.payload };
    else if (action instanceof IUpdateLinkButtonOptionsAction) {
        return produce(state, (draft) => {
            draft.instanceID = action.payload.instanceID;
        });
    } else if (action instanceof ILinkButtonSetLoadingAction) {
        return produce(state, (draft) => {
            draft.isLoading = action.payload.isLoading;
        });
    }
    return state;
};

const instanceKeyResolver = (action: AnyAction) => {
    return action?.meta?.dataKey;
};

const instanceMapReducer = createInstanceMapReducer(linkButtonReducer, instanceKeyResolver);

export const reducer: Reducer<LinkButtonMapState> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof ILinkButtonClearAction) {
        return produce(state, (draft) => {
            delete draft[action.meta.dataKey];
        });
    } else {
        const dataKey = instanceKeyResolver(action);
        if (state[dataKey] || action instanceof IInitLinkButtonAction) {
            // Do store ukládám pouze pokud je již instance vytvořená nebo pokud je akce inicializační
            return instanceMapReducer(state, action);
        }
        return state;
    }
};
